// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__bT1QQ","title":"Welcome_title__cw-ga","subtitle":"Welcome_subtitle__+WUf4"};